import { useContext, useEffect, useState } from "react";
import { CashOpeningBalancesDto } from "../dtos/CashOpeningBalancesDto";
import { FormProvider, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { CashOpeningBalancesDetailMain } from "./CashOpeningBalancesDetailMain";
import { CashOpeningBalancesDetailLines } from "./CashOpeningBalancesDetailLines";
import { CashOpeningBalancesDetailFooter } from "./CashOpeningBalancesDetailFooter";
import { CashOpeningBalancesModel } from "../models/CashOpeningBalancesModel";
import { NewDocumentModalViewContext } from "src/components/Shared/NewDocumentModalView";
import { NFTabs } from "src/components/Shared/NewForms/NFTabs";
import { NFSecondTab } from "src/components/Shared/NewForms/NFSecondTab";
import { NFTabContainer } from "src/components/Shared/NewForms/NFTabContainer";
import { useFetchCashOpeningBalances } from "../hooks/fetchDocument";
import DocumentDetailViewToolbar from "src/components/Shared/DetailViews/DocumentDetailViewToolbar";
import DetailViewPostButton from "src/components/Shared/DetailViews/DetailViewPostButton";
import DetailViewCancelButton from "src/components/Shared/DetailViewCancelButton";

interface IProps {
  id?: string;
}

export const CashOpeningBalancesDetail = ({ id }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<CashOpeningBalancesModel>();

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;

  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Cash Opening Balances");

  useEffect(() => {
    // console.log("formState errors");
    if (Object.keys(formState.errors).length != 0) {
      console.log("formState.errors", formState);
      toast.error("Please fill required fields");
    }
  }, [formState]);
  const { isDocumentLoading, documentModel, postDocument, cancelDocument, updateDocument } = useFetchCashOpeningBalances({ documentId: id });

  useEffect(() => {
    if (documentModel) {
      reset(documentModel);
    }
  }, [documentModel]);

  useEffect(() => {
    if (formState.isDirty) {
      console.log("formState.isDirty", formState.isDirty);
      updateDocument(getValues());
    }
  }, [formState.isDirty]);

  const handlePost = async () => {
    await postDocument();
  };

  const handleCancel = async () => {
    await cancelDocument();
  };

  // const exportToExcel = () => {
  //   const data = {
  //     ...model
  //   };
  //   const documentInfo = {
  //     title: AppEntities.CashOpeningBalances.title,
  //     number: model.documentNumber,
  //     date: model.documentDate
  //   };
  //   saveObjectToExcel(data, documentInfo);
  // };

  // const handleUploadFile = (file: File) => {
  //   importFromExcel(file, (data: any) => {
  //     reset(data);
  //   });
  // };

  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFSecondTab title={"Main"} />
        <NFSecondTab title={"Lines"} />
      </NFTabs>

      <div className={"modal-container-height"}>
        <DocumentDetailViewToolbar>
          <DetailViewPostButton onPost={handlePost} />
          <DetailViewCancelButton onCancel={handleCancel} />
        </DocumentDetailViewToolbar>

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <CashOpeningBalancesDetailMain />
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <CashOpeningBalancesDetailLines />
        </NFTabContainer>
      </div>
      <CashOpeningBalancesDetailFooter />
    </FormProvider>
  );
};
